"use strict";
Drupal.behaviors.cookieComplinanceStatus = {
    attach: function (context) {
        once('cookieComplinanceStatus', 'body').forEach(function (element) {
            // Select the body element
            const body = document.querySelector('body');
            const toggleCallToAction = document.querySelector('.js-toggle-call-to-action');
            const callToAction = document.querySelector('.js-call-to-action');
            // Create a new MutationObserver instance
            const observer = new MutationObserver(function (mutationsList, observer) {
                // Iterate through each mutation
                for (let mutation of mutationsList) {
                    // Check if the mutation is a class change on the body element
                    if (mutation.target === body &&
                        mutation.type === 'attributes' &&
                        mutation.attributeName === 'class') {
                        // Check if the "eu-cookie-compliance-status-null" class no longer exists
                        if (!body.classList.contains('eu-cookie-compliance-status-null')) {
                            if (callToAction && toggleCallToAction) {
                                callToAction.classList.add('opacity-100');
                                callToAction.classList.remove('opacity-0');
                                toggleCallToAction.classList.add('opacity-100');
                                toggleCallToAction.classList.remove('opacity-0');
                            }
                        }
                        else {
                            if (callToAction && toggleCallToAction) {
                                callToAction.classList.remove('opacity-100');
                                callToAction.classList.add('opacity-0');
                                toggleCallToAction.classList.remove('opacity-100');
                                toggleCallToAction.classList.add('opacity-0');
                            }
                        }
                    }
                }
            });
            if (body) {
                // Start observing the body element for attribute changes
                observer.observe(body, { attributes: true });
            }
        });
    },
};
